import {
  Table,
  Button,
  Tabs,
  TabPane,
  Form,
  FormItem,
  Select,
  Option,
  OptionGroup,
  Row,
  Col,
  Icon,
  Spin,
  Input,
  DatePicker,
  Message,
  Radio,
  RadioGroup, Poptip,
  Modal,
  Divider,
  Avatar, Affix, AutoComplete,
  List,
  Checkbox,
  CheckboxGroup,
  Notice, Dropdown, DropdownMenu, DropdownItem,
  locale,
  Switch, Collapse, Panel
} from 'view-design'
import Vue from 'vue'
import en from 'view-design/dist/locale/en-US';
import zh from 'view-design/dist/locale/zh-CN';
// locale(localStorage.getItem('locale') === 'zh' ? zh : en)
// import {Checkbox} from 'element-ui'

Vue.component('Table', Table)
Vue.component('Button', Button)
Vue.component('Tabs', Tabs)
Vue.component('TabPane', TabPane)
Vue.component('Form', Form)
Vue.component('FormItem', FormItem)
Vue.component('Select', Select)
Vue.component('Option', Option)
Vue.component('OptionGroup', OptionGroup)
Vue.component('Row', Row)
Vue.component('Col', Col)
Vue.component('Icon', Icon)
Vue.component('Spin', Spin)
Vue.component('Input', Input)
Vue.component('DatePicker',DatePicker)
Vue.component('Radio',Radio)
Vue.component('RadioGroup',RadioGroup)
Vue.component('Poptip', Poptip)
Vue.component('Modal',Modal)
Vue.component('CheckboxGroup', CheckboxGroup)
Vue.component('Checkbox', Checkbox)
Vue.component('Divider',Divider)
Vue.component('Avatar',Avatar)
Vue.component('Affix',Affix)
Vue.component('AutoComplete', AutoComplete)
Vue.component('iList', List)
Vue.component('iListItem', List.Item)
Vue.component('iListItemMeta', List.Item.Meta)
Vue.component('iDropdown', Dropdown)
Vue.component('iDropdownItem', DropdownItem)
Vue.component('iDropdownMenu', DropdownMenu)
Vue.component('iSwitch', Switch)
Vue.component('Collapse', Collapse)
Vue.component('Panel', Panel)


Vue.prototype.$iSpin = Spin
Vue.prototype.$iMessage = Message
Vue.prototype.$iNotice = Notice
Vue.prototype.$iLocale = locale

